import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import SelectedTick from "../../../../assets/images/selected-tick.svg";
const StyledGender = styled.div`
    &.dropdown-mini,
    &.dropdown-mini * {
        box-sizing: border-box;
    }
    &.dropdown-mini {
        background: var(--surface-surface-tertiary, #212121);
        border-radius: 4px;
        padding: 8px 4px 8px 4px;
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: flex-start;
        justify-content: flex-start;
        width: 215px;
        position: absolute;
        box-shadow: var(--dropdown-ds-box-shadow, 0px 0px 10px 0px rgba(17, 22, 32, 1));
        z-index: 9;
        margin-top: 5px;
    }
    .frame-75 {
        display: flex;
        flex-direction: column;
        gap: 0px;
        align-items: flex-start;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-79 {
        border-radius: 4px;
        padding: 8px;
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .checkbox {
        display: flex;
        flex-direction: row;
        gap: 12px;
        align-items: center;
        justify-content: flex-start;
        flex-shrink: 0;
        height: auto;
        position: relative;
        overflow: visible;
    }
    .frame-313638 {
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        justify-content: flex-start;
        flex: 1;
        position: relative;
    }
    .both {
        color: var(--text-text-primary, #ffffff);
        text-align: left;
        font-family: "OpenSans-Regular", sans-serif;
        font-size: 16px;
        font-weight: 400;
        position: relative;
        flex: 1;
    }
    .check {
        flex-shrink: 0;
        width: 14px;
        height: 14px;
        position: relative;
        overflow: hidden;
    }
    .frame-85 {
        border-radius: 4px;
        padding: 8px;
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
        cursor: pointer;
    }
    .frame-85:hover {
        background: var(--surface-surface-tertiary-hover, #282828);
    }
    .checkbox2 {
        display: flex;
        flex-direction: row;
        gap: 12px;
        align-items: center;
        justify-content: flex-start;
        flex-shrink: 0;
        position: relative;
    }
    .ellipse-1 {
        border-radius: 50%;
        border-style: solid;
        border-color: var(--border-border-secondary, #8c8f93);
        border-width: 1px;
        flex-shrink: 0;
        width: 18px;
        height: 18px;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .frame-313640 {
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        justify-content: flex-start;
        flex: 1;
        position: relative;
    }
    .men {
        color: var(--text-text-primary, #ffffff);
        text-align: left;
        font-family: "OpenSans-Regular", sans-serif;
        font-size: 16px;
        font-weight: 400;
        position: relative;
        flex: 1;
    }
    .frame-84 {
        background: var(--surface-surface-tertiary-hover, #282828);
        border-radius: 4px;
        padding: 8px;
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-313639 {
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        justify-content: flex-start;
        flex: 1;
        position: relative;
    }
    .women {
        color: var(--text-text-primary, #ffffff);
        text-align: left;
        font-family: "OpenSans-Regular", sans-serif;
        font-size: 16px;
        font-weight: 400;
        position: relative;
        flex: 1;
    }
    .frame-3136392 {
        padding: 0px 4px 0px 4px;
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        justify-content: flex-end;
        align-self: stretch;
        flex-shrink: 0;
        height: 30px;
        position: relative;
    }
    .btn-xs-primary {
        background: var(--salmon, #f7665f);
        border-radius: 5px;
        padding: 10px;
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        height: 30px;
        position: relative;
        cursor: pointer;
    }
    .button {
        color: var(--text-text-primary, #ffffff);
        text-align: center;
        font-family: var(--button-text-small-font-family, "OpenSans-Regular", sans-serif);
        font-size: var(--button-text-small-font-size, 12px);
        line-height: var(--button-text-small-line-height, 16px);
        font-weight: var(--button-text-small-font-weight, 400);
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
    }
`;
export default function Gender({
    selectedType,
    setSelectedType,
    setShowImageType,
    setShowGenderFilter,
    setShowAgeGroupFilter,
    searchFunction
}) {
    const navigate = useNavigate();
    const updateGenderInUrl = gender => {
        const searchParams = new URLSearchParams(window.location.search);
        if (gender === "Both") {
            searchParams.delete("gender");
        } else {
            searchParams.set("gender", gender);
        }
        navigate({ search: searchParams.toString() });
    };
    return (
        <StyledGender className="dropdown-mini">
            <div className="frame-75">
                <div
                    className="frame-85"
                    onClick={() => {
                        setSelectedType("Both");
                        updateGenderInUrl("Both");
                    }}>
                    <div className="checkbox2">
                        <div className="ellipse-1">
                            {selectedType === "Both" && <img className="checkbox" src={SelectedTick} alt="checkbox0.svg" />}
                        </div>
                    </div>
                    <div className="frame-313638">
                        <div className="both">Both</div>
                    </div>
                </div>
                <div
                    className="frame-85"
                    onClick={() => {
                        setSelectedType("Men");
                        updateGenderInUrl("Men");
                    }}>
                    <div className="checkbox2">
                        <div className="ellipse-1">
                            {selectedType === "Men" && <img className="checkbox" src={SelectedTick} alt="checkbox0.svg" />}
                        </div>
                    </div>
                    <div className="frame-313640">
                        <div className="men">Men</div>
                    </div>
                </div>
                <div
                    className="frame-85"
                    onClick={() => {
                        setSelectedType("Women");
                        updateGenderInUrl("Women");
                    }}>
                    <div className="checkbox2">
                        <div className="ellipse-1">
                            {selectedType === "Women" && <img className="checkbox" src={SelectedTick} alt="checkbox0.svg" />}
                        </div>
                    </div>
                    <div className="frame-313639">
                        <div className="women">Women</div>
                    </div>
                </div>
            </div>
            <div className="frame-3136392">
                <div
                    className="btn-xs-primary"
                    onClick={e => {
                        e.stopPropagation();
                        setShowGenderFilter(false);
                        searchFunction();
                    }}>
                    <div className="button">Done</div>
                </div>
            </div>
        </StyledGender>
    );
}
